<template>
  <div class="page">
    <van-nav-bar :title="$t('nHomeText1')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="detail-title">{{ xuanfeidata.xuanfei_name }}</div>
    <div style="display: flex;">
      <div :class="active == 0?'detail-tabs active':'detail-tabs'" @click="active = 0">
        <img v-if="active == 0" src="img/ico-info.31a6afcb.png" alt="" class="detail-tabs-ico">
        <img v-else src="img/ico-info-active.448ecd34.png" alt="" class="detail-tabs-ico">
        {{ $t("info") }}
      </div>
      <div :class="active == 1?'detail-tabs active':'detail-tabs'" @click="active = 1">
        <img v-if="active == 1" src="img/ico-img.c08d0ee9.png" alt="" class="detail-tabs-ico">
        <img v-else src="img/ico-img-active.fc388b3a.png" alt="" class="detail-tabs-ico">
        {{ $t("images") }} ({{ xuanfeidata.img_url.length }})
      </div>
      <div :class="active == 2?'detail-tabs active':'detail-tabs'" @click="active = 2">
        <img v-if="active == 2" src="img/ico-notice.bdf0d3b7.png" alt="" class="detail-tabs-ico">
        <img v-else src="img/ico-notice-active.18e68919.png" alt="" class="detail-tabs-ico">
        {{ $t("reprot") }} ({{ commentList.length }})
      </div>
    </div>
    <div class="detail-content" v-if="active == 0">
      <div class="movie-list-n-img">
        <div class="movie-list-n-img van-image">
          <img :src="xuanfeidata.img_url[0].img" alt=""
               class="van-image__img" style="object-fit: cover;"></div>
        <div class="movie-list-n-lab">{{ xuanfeidata.address }}</div>
      </div>
      <div class="movie-list-n-item-bottom">
        <div class="movie-n-time-div">
          <img v-for="k in xuanfeidata.number" :key="k" src="img/ico-love.e61811a3.png" lt=""
               class="movie-list-ico-loves"/>
          <div class="movie-list-money"><img
              src="data:image/png;base64,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"
              alt="" class="movie-list-ico-money" style="width: 20px;">{{ xuanfeidata.price }}
          </div>
          <div class="movie-list-addr"><img src="img/ico-addr.95fc5c8d.png" alt="" class="movie-list-ico-addr">
            {{ xuanfeidata.city }}
          </div>
          <div class="movie-list-notice"><img src="img/ico-time.8c3feaf4.png" alt="" class="movie-list-ico-notice">
            {{ xuanfeidata.birthday }}
          </div>
        </div>
      </div>
      <div class="table-title">{{ $t("Specifications") }}</div>
      <div class="table">

        <div class="table-list">
          <div class="name">{{ $t("mine.detail") }}</div>
          <div class="content">{{ xuanfeidata.attributes[70] }}</div>
        </div>

        <div class="table-list">
          <div class="name">Pass</div>
          <div class="content"></div>
        </div>
        <div class="table-list">
          <div class="name">{{ $t("YearOfBirth") }}</div>
          <div class="content">{{ xuanfeidata.attributes[42] }}</div>
        </div>
        <div class="table-list">
          <div class="name">{{ $t("high") }} (cm)</div>
          <div class="content">{{ xuanfeidata.attributes[46] }}</div>
        </div>
        <div class="table-list">
          <div class="name">{{ $t("Heavy") }} (kg)</div>
          <div class="content">{{ xuanfeidata.attributes[48] }}</div>
        </div>
        <div class="table-list">
          <div class="name">{{ $t("Round") }} 1 (cm)</div>
          <div class="content">{{ xuanfeidata.attributes[49] }}</div>
        </div>
        <div class="table-list">
          <div class="name">{{ $t("Round") }} 2 (cm)</div>
          <div class="content">{{ xuanfeidata.attributes[50] }}</div>
        </div>
        <div class="table-list">
          <div class="name">{{ $t("Round") }} 3 (cm)</div>
          <div class="content">{{ xuanfeidata.attributes[51] }}</div>
        </div>
        <div class="table-list">
          <div class="name">{{ $t("refuse") }}</div>
          <div class="content">{{ xuanfeidata.attributes[58] }}</div>
        </div>
      </div>
    </div>
    <div class="detail-content" v-if="active == 1">
      <div class="tabs1 ">
        <div class="tabs1-img van-image" lazy="loaded" v-for="(item,key) in xuanfeidata.img_url" :key=key>
          <img :src="item.img" alt=""
               class="van-image__img" style="object-fit: cover;">
        </div>
      </div>
    </div>
    <div class="detail-content" v-if="active == 2">
      <div class="table-title"> {{ $t("nHomeText2") }}</div>
      <div class="comment">
        <div class="commentList">

          <div class="commentList-content" v-for="(item,key) in commentList" :key="key">
            <img class="commentList-content-avatar"
                 src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading">
            <div style="width: 100%;">
              <div>
                <div class="commentList-content-name">{{ item.nickname }}</div>
                <div class="commentList-content-txt">{{ item.message }}
                </div>
              </div>
              <div>
                <div class="commentList-content-bottom commentList-content-time" v-if="item.children.length > 0">
                  <div class="commentList-content-left" v-if="item.status == 1" @click="item.status = 0">
                    {{ $t("CurrentlyAnswers").replace("2", item.children.length) }}<i
                      class="van-icon van-icon-arrow-down"></i>
                  </div>

                  <div class="commentList-content-left" v-if="item.status == 0" @click="item.status = 1">
                    {{$t("HideReplies")}}
                    <i class="van-icon van-icon-arrow-up"></i>
                  </div>
                </div>
                <div  v-if="item.status == 0">
                    <div class="commentList-content-r" style="margin-top: 10px;"  v-for="(item1,keys) in item.children" :key="keys">
                      <img class="commentList-content-avatar"
                           src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                           lazy="error">
                      <div>
                        <div>
                          <div class="commentList-content-name">{{ item1.nickname }}</div>
                          <div class="commentList-content-txt">{{ item1.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vod_name: "",
      imgs_url: "",
      xuanfeidata: [],
      atr: 0,
      active: 0,
      commentList: []
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: {id: this.$route.query.id}
      }).then(res => {
        this.xuanfeidata = res.data;
        this.imgs_url = res.data.img_url[0].img;

        this.nowPlayVideoUrl = this.xuanfeidata.pvideo;
        this.isMp4 = 1;
        this.cover = "";

      });
    },

    getcommentList() {
      this.$http({
        method: 'get',
        url: 'commentList',
        data: {id: this.$route.query.id}
      }).then(res => {
        this.commentList = res.data;
      });
    },
    yuyue() {
      this.$toast(this.$t("msg.请联系顾问或接待员"));
    }
  },
  created() {
    this.vod_name = this.$route.query.name;
    this.getxuanfeidata();
    this.getcommentList();
  }
};
</script>

<style>
.detail-title {
  font-size: 5.333vw;
  margin: 2.667vw 0;
}

.detail-tabs.active {
  color: #f905e5;
}

.detail-tabs {
  color: #e74c3c;
  font-size: 4vw;
  flex: 1;
  padding: 5.333vw 2.667vw;
  align-items: center;
  display: flex;
  justify-content: center;
}

.movie-list-n-img {
  width: 100vw;
  height: 100vw;
  position: relative;
}

.movie-list-n-lab {
  display: inline;
  position: absolute;
  top: 2vw;
  left: 2vw;
  padding: .2em .6em .3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25em;
  background-color: #f905e5;
  width: 42vw;
  overflow: hidden;
}

.movie-list-n-item-bottom {
  padding: 4vw;
}

.movie-list-ico-loves {
  display: inline-block;
  width: 5.333vw;
}

.movie-list-money {
  display: flex;
  align-items: center;
  margin-top: 1.333vw;
}

.movie-list-addr {
  display: flex;
  align-items: center;
  margin-top: 1.333vw;
}

.movie-list-ico-addr {
  width: 4vw;
  display: inline-block;
  margin-right: 1.333vw;
}

.movie-list-notice {
  display: flex;
  align-items: center;
  margin-top: 1.333vw;
}

.movie-list-ico-notice {
  width: 4vw;
  display: inline-block;
  margin-right: 1.333vw;
}

.table-title {
  padding: 4vw;
  font-size: 4.8vw;
  background: #ccc;
  border-bottom: 1px solid #eee;
}

.table .table-list {
  padding: 2.667vw 4vw;
  display: flex;
  background: #eee;
}

.table .table-list .name {
  width: 30%;
  display: flex;
  align-items: center;
}

.name {
  font-size: 1.125rem;
}

.table .table-list:nth-child(2n) {
  background: #999;
}

.detail-tabs-ico {
  width: 4vw;
  margin-right: 1.333vw;
}

.table .table-list .content {
  width: 70%;
}

.tabs1 {
  display: flex;
  flex-wrap: wrap;
}

.tabs1-img {
  width: 50%;
  padding: 1.333vw;
}

.comment {
  padding: 4vw;
}

.commentList-content {
  display: flex;
  margin-bottom: 4vw;
  font-size: 3.733vw;
}

.commentList-content-avatar {
  width: 8vw;
  height: 8vw;
  margin-right: 2.667vw;
}

.commentList-content-name {
  margin-bottom: 1.333vw;
  color: #f905e5;
  font-weight: 700;
}

.commentList-content-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.333vw;
}

.commentList-content-left {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #f905e5;
}
.commentList-content-r {
  margin-left: 2.667vw;
  display: flex;
}
</style>
